import React from 'react';
import { EventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { ListingInfoPill } from '../listing-info-pill';
import { jsx as ___EmotionJSX } from "@emotion/core";
var DISCLAIMER = 'This price guide has been provided by the agent as an estimate only.';
export var PriceGuidePill = _ref => {
  var priceGuide = _ref.priceGuide;
  return ___EmotionJSX(EventBoundary, {
    name: "price-guide"
  }, ___EmotionJSX(ListingInfoPill, {
    label: "Price guide",
    details: priceGuide,
    infoText: DISCLAIMER
  }));
};